import {
    ACTIVATE_USER_DATA,
    ADD_USER_DATA,
    DEACTIVATE_USER_DATA,
    GET_USERS,
    LOCK_USER_DATA,
    UPDATE_USER_DATA,
} from "./admin.actionsTypes";

const updateUser = (roleGroup, action) => {
    let movedUser = null;
    if (!roleGroup || !Array.isArray(roleGroup.users)) return movedUser;
    for (let i = 0; i < roleGroup.users.length; i++) {
        if (roleGroup.users[i]._id === action.id) {
            const updated = { ...roleGroup.users[i], ...action.user };
            if (roleGroup.users[i].role !== action.user.role) {
                roleGroup.users.splice(i, 1);
                movedUser = updated;
            } else {
                roleGroup.users[i] = updated;
            }
            break;
        }
    }
    return movedUser;
};

export default function users(state = [], action) {
    let newState = Object.assign([], state);
    switch (action.type) {
        case GET_USERS:
            return Object.assign([], action.users);
        case LOCK_USER_DATA:
            for (let i = 0; i < newState.length; i++) {
                for (let k = 0; k < newState[i].users.length; k++) {
                    if (newState[i].users[k]._id === action.user.id) {
                        newState[i].users[k].locked = action.user.locked;
                    }
                }
            }
            return newState;
        case DEACTIVATE_USER_DATA:
        case ACTIVATE_USER_DATA:
            for (let i = 0; i < newState.length; i++) {
                for (let k = 0; k < newState[i].users.length; k++) {
                    if (newState[i].users[k]._id === action.user.id) {
                        newState[i].users[k].isDeactive =
                            action.user.isDeactive;
                    }
                }
            }
            return newState;
        case ADD_USER_DATA:
            for (let i = 0; i < newState.length; i++) {
                if (newState[i] && newState[i].role == action.user.role && Array.isArray(newState[i].users)) {
                    newState[i].users.push(action.user);
                }
            }
            return newState;
        case UPDATE_USER_DATA:
            let updatedObj, roleIndex;
            for (let i = 0; i < newState.length; i++) {
                if (newState[i] && newState[i].role == action.user.role) {
                    roleIndex = i;
                }
                if (!updatedObj) {
                    updatedObj = updateUser(newState[i], action);
                } else {
                    continue;
                }
            }

            if (updatedObj) {
                if (roleIndex !== undefined && newState[roleIndex] && Array.isArray(newState[roleIndex].users)) {
                    newState[roleIndex].users.push(updatedObj);
                }
            }
            return newState;
        default:
            return newState;
    }
}
